module.exports = __webpack_public_path__ + "img/kf.95356cfe.png";